import { useTranslation } from '@supply-mover-2-0/web-ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AccountBreadcrumb } from '../components/AccountBreadcrumb';
import { MobilePageHeader } from '../components/layout/MobilePageHeader';
import { PaymentMethodsSection } from '../components/PaymentMethodsSection';
import { usePortalAuth } from '../hooks/usePortalAuth';
import { useLoginModalStore } from '../stores/loginModalStore';

/**
 * Payment methods management (PD-14080) — the full list with add/remove/set
 * primary, moved off the account home (which now shows only the primary
 * method with a link here).
 */
export function PaymentMethodsPage(): JSX.Element {
	const { t } = useTranslation();
	const { isAuthenticated } = usePortalAuth();
	const openLoginModal = useLoginModalStore((s) => s.open);
	const [searchParams] = useSearchParams();
	const autoOpenAddPayment = searchParams.get('addPayment') === 'true';

	useEffect(() => {
		if (!isAuthenticated) {
			openLoginModal();
		}
	}, [isAuthenticated, openLoginModal]);

	if (!isAuthenticated) {
		return <div />;
	}

	return (
		<div className="px-4 py-4 max-w-4xl mx-auto">
			<MobilePageHeader title="Payment Methods" backPath="/account" />
			<AccountBreadcrumb current="Payment Methods" />
			<h1 className="hidden md:block text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100 mb-4">
				{t('Payment Methods')}
			</h1>
			<PaymentMethodsSection autoOpenAdd={autoOpenAddPayment} />
		</div>
	);
}
